import constantes from '../helpers/constanteHelper'

import Button from 'react-bootstrap/Button'

import { FaPlusCircle, FaEye, FaSearch, FaArrowLeft, FaCheck, FaTimes, FaCopy, FaExclamationTriangle, FaHome, FaCalculator, FaSave, FaFileExport, FaGlobe, FaRegFileAlt, FaMapMarkerAlt } from 'react-icons/fa'

function _retornarIcone(icone) {
    const icones = {
        incluir: <FaPlusCircle size={25} />,
        visualizar: <FaEye size={25} />,
        buscar: <FaSearch size={25} />,
        voltar: <FaArrowLeft size={25} />,
        confirmar: <FaCheck size={25} />,
        cancelar: <FaTimes size={25} />,
        copiar: <FaCopy size={25} />,
        aviso: <FaExclamationTriangle size={25} />,
        home: <FaHome size={25} />,
        calcular: <FaCalculator size={25} />,
        salvar: <FaSave size={25} />,
        exportar: <FaFileExport size={25} />,
        site: <FaGlobe size={25} />,
        bula: <FaRegFileAlt size={25} />,
        pontosVenda: <FaMapMarkerAlt size={25} />,
    }

    return icones[icone]
}

function Botao({ texto, icone, funcao, largura, altura, variante, cor, corTexto, desabilitado }) {
    const regraCor = variante === 'danger' ? constantes.CORES.VERMELHO_PADRAO : variante === constantes.CORES.VERDE_SUCESSO_PADRAO ? '#58BF8E' : desabilitado ? constantes.CORES.CINZA_PADRAO : cor ? cor : constantes.CORES.VERDE_PRIMARIO

    const style = {
        width: largura ? `${largura}px` : '200px',
        height: altura ? `${altura}px` : '50px',
        background: regraCor,
        borderColor: regraCor,
        fontSize: '18px',
        fontWeight: 600,
        color: corTexto ? corTexto : constantes.CORES.BRANCO_PADRAO
    }

    return (
        <Button disabled={desabilitado ? true : false} type='submit' style={style} onClick={funcao ? funcao : () => { }} className='d-flex align-items-center justify-content-center mt-3'>
            {_retornarIcone(icone)}
            <div style={{ width: icone ? '15px' : '0px' }}></div>
            {texto}
        </Button>
    );
}
export default Botao;
